module.exports = __webpack_public_path__ + "static/media/map-preview.4ba2bc4c.png";